<template lang="pug">
.reply-receive-message-tab(v-cloak)
  .box-body
    .message-histories.d-flex.flex-row.flex-nowrap.align-items-stretch
      // left side list
      .message-list.d-flex.flex-column
        .message-list-title
          div(v-if="currentOpinion.familyName && 0 < messages.length")
            span(v-if="currentOpinion.functionContents && currentOpinion.functionContents.hidden") 匿名からのメッセージと回答履歴
            span(v-else) {{ currentOpinion.familyName }}様からのメッセージと回答履歴
        .message-content(v-BottomScroll)
          .message(v-for="message in messages")
            .line-message(:class="{ 'line-left' : message.senderType == 0, 'line-right': message.senderType == 1 }")
              .text
                template(v-for="content in createSendMessageContents(message)")
                  .text-content.pre-line(v-if="content.type == 'text'")
                    span {{ content.value }}
                  .link-content.text-center(v-else-if="content.type == 'link'" style="padding: 4px;")
                    a(:href="content.uri" target="_blank") {{ content.value }}
                  .image-content(v-else-if="content.type == 'image'")
                    .image
                      img(:src="content.url" @click="showImage(content.url, content.fileName)")
                  .pdf-content(v-else-if="content.type == 'pdf'")
                    .pdf.flex.flex-send-message
                      .title.pre-line 添付ファイル
                      .text.pre-line
                        span PDFの添付ファイルがあります。
                        br
                        span ファイル名：{{ content.fileName }}
                      .link
                        a(@click="showPdf(content)") PDFファイルを開く
              .date {{ convertDate(message.sendTime) }}
      .reply-content.d-flex.flex-column
        .message-list-title
          span 返信内容入力欄
        .reply-input.d-flex.flex-wrap.align-items-stretch.register-body
          .mt-2
          FormTextarea(v-model="text" key-name="返信内容" name="text" placeholder="返信内容" :validation-rules="{ required: true, max: 1000 }" 
            :maxlength="1000" :styles="{ minWidth: '420px', width: '100%', minHeight: '160px' }" required)
            template(#question)
              HelpIcon(popoverId="message-url-help" title="リンクの記載について")
                template(v-slot:text)
                  span メッセージ内でURLリンクを使用したい場合は、改行してURLを記載することでリンクを送ることができます。
                  br
                  br
                  strong 記載例
                  br
                  span 以下のリンクからコニカミノルタへアクセスしてください。
                  br
                  span https://www.konicaminolta.com
                  br
                  br
                  strong リンク名を付ける方法
                  br
                  span 以下のようにリンク名とURLを記載すると、リンク名を表示することができます。
                  br
                  span [リンク名](URL)
                  br
                  br
                  strong 記載例（リンク名を付ける方法）
                  br
                  span [HitomeQ](https://konicaminolta.com)
          .register-body(v-if="1 <= planType")
            .register-row
              .register-group
                .register-key
                  .left-side.d-flex
                    span.key-name 添付ファイル
                    span.comment ※最大4ファイルまで登録可能です
                  .right-side
                    HelpIcon(popoverId="temp-files-help" :title="'選択可能なファイルについて'")
                      template(#text)
                        span 選択可能なファイルは、写真（jpeg、png）、pdfです。
                        br
                        span pdfはそのまま送るか、画像に変換して送るかをファイルごとに選択できます。
                        span 画像に変換した場合は、LINEですぐに見ることができます。
                        br
                        span ファイルサイズが大きいと送信に時間がかかりますので、なるべく小さいサイズにしてください。
                .register-value
                  .d-flex.flex-column
                    MultiFileSelecter(:mimetypes="['image/jpeg', 'image/png', 'application/pdf']"
                      width="450px" height="74px" :limit="_registerImageFilesLimit" :showPreview="true" :enablePreviewStatus="_enablePreviewStatus"
                      @input="inputFiles" @preview="onTempFilePreview")
                    label.need-convert-pdf
                      input(v-model="needConvertPdf" name="need-convert-pdf" type="checkbox")
                      span.text PDFファイルの場合、画像に変換する
                    input(name="tempfiles-multiple-register-errors" data-vv-as="添付ファイル" style="display: none")
                    .error-messages.text-break(v-for="error in errors.collect('tempfiles-multiple-register-errors')" :style="{ 'maxWidth': '500px' }")
                      label.error-message {{ error }}
                      br
            .register-row
              DraggableFiles(v-model="files" @delete="onFileDelete" :item-width="'468px'")
          .register-body(v-if="planType < 1")
            .register-row
              .register-group
                .register-key
                  .left-side.d-flex
                    span.key-name 添付ファイル
                .register-value
                  button#disable-file-select-btn.btn.disable(type="button") ファイルを選択
                  b-popover(target="disable-file-select-btn" triggers="hover" placement="top")
                    template(v-slot:title) 添付ファイル
                    span 写真・PDFをメッセージに添付できます。
                    br
                    span ※ ライトプラン以上で使用可能

          .buttons.d-flex.flex-wrap.justify-content-end.align-items-stretch.align-content-center.mr-2
            button.btn.reply-btn.mb-2(@click="onReplyButton") 送信

  SendMessageFilePreviewModal(ref="previewModal")
  ImageDownloadModal(v-model="showImageDownloadModal" :url="imageUrl" :fileName="imageFileName")
  PdfModal(v-model="showPdfModal" :pdfUrl="pdfUrl")

  OkCancelModal(v-model="showSendMessageModal" :title="sendMessageTitle" @ok="sendReplyMessage")
  OkModal(v-model="showSendMessageSuccessModal" title="メッセージの返信に成功しました。")
  OkModal(v-model="showSendMessageFaildModal" title="メッセージの返信に失敗しました。\n対象のユーザーのLINE IDが削除されている可能性があります。")

  //- file upload error modal
  FileUploadErrorModal(v-model="showUploadErrorModal")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
  ProgressLoading(v-model="currentUploadCount" :max="uploadCount" :isBusy="progressLoading" :message="progressMessage")
</template>

<script lang="ts">
import { Component, Inject, Prop, Ref, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import SystemError from "@/commons/models/SystemError";

import OpinionMessagesService, { OpinionMessagesGetModel, SendType, OpinionMessagesPostModel, AttachedFile } from "@/commons/services/OpinionMessages";
import DraggableFile from "@/commons/models/DraggableFile";
import { PlanType } from "@/commons/services/Plans";
import ReceiveMessageFormCommon from "@/commons/services/ReceiveMessageFormCommon";
import S3LocationsService from "@/commons/services/S3Locations";
import { S3LocationRequest, S3LocationResponse, S3LocationType, S3LocationReceiveMessage } from "@/commons/models/S3Location";
import S3UploadsService from "@/commons/services/S3Uploads";
import ExistS3FilesService, { ExistS3FilesPostModel } from "@/commons/services/ExistS3Files";

import FileReaderWrapper from "@/commons/utils/FileReaderWrapper";

import FileUploadErrorModal from "@/pc/basics/FileUploadErrorModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import BottomScroll from "@/pc/basics/BottomScroll";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ContactConfirmSwitch from "@/pc/basics/ContactConfirmSwitch.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";
import DraggableFiles from "@/pc/components/DraggableFiles.vue";
import SendMessageFilePreviewModal from "@/pc/components/modals/SendMessageFilePreviewModal.vue";
import PdfModal from "@/pc/basics/PdfModal.vue";
import ImageDownloadModal from "@/pc/basics/ImageDownloadModal.vue";
import ProgressLoading from "@/pc/basics/ProgressLoading.vue";

/**
 * 家族からの連絡画面コンポーネント
 */
@Component({
  components: {
    FileUploadErrorModal,
    ContactConfirmSwitch,
    OkCancelModal,
    OkModal,
    PageLoading,
    FormTextarea,
    MultiFileSelecter,
    DraggableFiles,
    SendMessageFilePreviewModal,
    PdfModal,
    ImageDownloadModal,
    ProgressLoading,
    HelpIcon
  },
  directives: {
    BottomScroll
  },
  $_veeValidate: { validator: "new" }
})
export default class ReplyFamilyOpinionTab extends Vue {
  /** 意見メッセージサービス */
  @Inject("OpinionMessagesService") opinionMessagesService!: OpinionMessagesService;
  /** S3格納先URLサービス */
  @Inject("S3LocationsService") s3LocationsService!: S3LocationsService;
  /** S3ファイルアップロードサービス */
  @Inject("S3UploadsService") s3UploadsService!: S3UploadsService;
  /** S3ファイル存在確認サービス */
  @Inject("ExistS3FilesService") existS3FilesService!: ExistS3FilesService;

  @Ref()
  previewModal!: SendMessageFilePreviewModal;

  /** 選択中の意見 */
  @Prop()
  currentOpinion!: OpinionMessageTableItem;
  /** 意見にひもづくメッセージ */
  @Prop()
  messages!: Array<OpinionMessagesGetModel>;
  /** プラン種別 */
  @Prop()
  planType!: PlanType;

  /** ファイル登録数上限 */
  readonly fileUploadLimit: number = 4;

  /** 添付許可Content-Typeリスト */
  readonly allowContentType = ["image/jpeg", "image/png", "application/pdf"];
  readonly allowMessageType = ["image", "image", "pdf"];

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 画像モーダルの表示可否 */
  showImageDownloadModal: boolean = false;
  /** 画像モーダルで表示する画像のURL */
  imageUrl: string = "";
  /** 画像のファイル名 */
  imageFileName: string = "";

  /** PDFモーダルの表示可否 */
  showPdfModal: boolean = false;
  /** PDFモーダルで表示するPDFのURL */
  pdfUrl: string = "";

  /** 返信メッセージ */
  text: string = "";
  /** 返信メッセージ添付ファイル */
  files: Array<DraggableFile> = [];
  /** 添付ファイルのPDFを変換するか否か */
  needConvertPdf: boolean = false;

  /** メッセージ送信確認モーダルタイトル */
  sendMessageTitle: string = "";
  /** メッセージ送信確認モーダル表示可否 */
  showSendMessageModal: boolean = false;
  /** メッセージ送信完了モーダル表示可否 */
  showSendMessageSuccessModal: boolean = false;
  /** メッセージ送信失敗モーダル表示可否 */
  showSendMessageFaildModal: boolean = false;

  /** 現在のアップロード数 */
  currentUploadCount: number = 0;
  /** アップロード数最大値 */
  uploadCount: number = 0;
  /** プログレス付きローディング表示可否 */
  progressLoading: boolean = false;
  /** プログレス付きローディングメッセージ */
  progressMessage: string = "";

  /** ファイルアップロードエラーモーダル表示可否 */
  showUploadErrorModal: boolean = false;

  /** ### 登録可能なファイル数を返す */
  get _registerImageFilesLimit(): number {
    const limit: number = this.fileUploadLimit - this.files.length;
    return limit;
  }

  /** ファイルプレビューのボタン活性化可否 */
  get _enablePreviewStatus(): boolean {
    return 0 < this.files.length ? true : false;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    return;
  }

  /**
   * ### 返信確認ダイアログ
   */
  public async onReplyButton(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    const fileValidationResult: boolean = this.validateFiles();
    if (validationResult && fileValidationResult) {
      this.sendMessageTitle = `${this.currentOpinion.familyName}様のメッセージに返信します。よろしいですか？`;
      this.showSendMessageModal = true;
    }
    return;
  }

  /**
   * ### ファイルバリデーション
   *
   * - 何らかの原因でファイルが存在しないパターンがあったので、チェック処理を行う
   */
  public validateFiles(): boolean {
    for (const file of this.files) {
      if (!file || !file.name || file.size == 0) {
        this.$validator.errors.add({
          field: "tempfiles-multiple-register-errors",
          msg: `ファイルが破損等をしている可能性があり、ファイルを認識することができません。お手数ですが、再度選択し直してください。`
        });
        return false;
      }
    }
    return true;
  }

  /**
   * ### 返信内容を登録する
   */
  public async sendReplyMessage(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "返信中...";

    try {
      // ファイルアップロードするタイミングでファイルが削除（移動含む）、リネームされた場合は失敗するのでここでtry-catchする
      // アップロードに失敗した場合は添付されたファイルを全てリセットしてモーダルで再添付を促す
      let uploadedFiles: { fileUrls: string[]; fileNames: string[] } = { fileUrls: [], fileNames: [] };
      try {
        // ファイルのアップロード
        uploadedFiles = await this.uploadFiles();
      } catch (error) {
        this.isBusy = false;

        this.showUploadErrorModal = true;
        this.files = [];

        return;
      }

      // 返信内容を意見メッセージとして登録する
      let requestBody: OpinionMessagesPostModel = this.createRequestBody(uploadedFiles);
      const caseId: number = this.currentOpinion.caseId;
      await this.opinionMessagesService.post(userStore, caseId, requestBody);

      // 登録したメッセージを追加して画面情報を更新する
      // messagesの0件目の情報を流用して各情報を作成する
      const date: Date = new Date();
      const datetime: number = this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMMss000");
      const message: OpinionMessagesGetModel = {
        facilityId: this.messages[0].facilityId,
        caseId: this.messages[0].caseId,
        familyRelation: this.messages[0].familyRelation,
        familyPosition: this.messages[0].familyPosition,
        content: this.$stringUtil.convertYen(this.text),
        sender: "bot",
        senderType: SendType.FACILITY,
        sendTime: datetime,
        receiver: this.messages[0].sender,
        attachedFiles: await this.createAttachedFiles()
      };
      this.messages.push(message);
      // 返信内容はクリアする
      this.text = "";
      this.files = [];

      // 返信成功ダイアログを表示する
      this.showSendMessageSuccessModal = true;
    } catch (error) {
      // ステータスコード500の場合、メッセージ送信失敗として扱う
      const systemError: SystemError = error as SystemError;
      if (systemError.statusCode == 500) {
        this.showSendMessageFaildModal = true;
      }
      // 500以外の場合は例外を投げなおして共通エラーハンドラーに渡す
      throw error;
    } finally {
      this.isBusy = false;
    }

    return;
  }

  public async uploadFiles(): Promise<{ fileUrls: string[]; fileNames: string[] }> {
    // ファイルが存在すればアップロードする
    const fileUrls: string[] = [];
    const fileNames: string[] = [];

    try {
      if (0 < this.files.length) {
        const urls: Array<S3LocationResponse> = await this.createUploadUrls(this.files, S3LocationType.RECEIVE_MESSAGES);

        // プログレス付きモーダルを表示する
        // 進捗はファイルのアプロード状況を反映させるようにする
        this.currentUploadCount = 0;
        this.uploadCount = this.files.length;
        this.progressMessage = "ファイルアップロード中。\n完了するまでそのままお待ちください。\nメッセージ送信中に別画面に遷移しますと処理がキャンセルされます。";
        this.progressLoading = true;
        // アップロード
        for (let i = 0; i < urls.length; i++) {
          this.currentUploadCount = i;
          await this.s3UploadsService.uploadFile(urls[i], this.files[i]);

          // DBにはファイルではなく、添付ファイルのS3URLを保持するためURL配列を作成する
          const preUrl: string = urls[i].url.endsWith("/") ? urls[i].url : `${urls[i].url}/`;
          const s3Url: string = `${preUrl}${urls[i].fields["key"]}`;
          fileUrls.push(s3Url);
        }
        // アップロードしたファイルはサムネイル画像が作成されたり、movからmp4への変換が行われる
        // ファイルの存在確認をして変換されたか確認する
        await this.existFile(fileUrls);

        for (const file of this.files) {
          fileNames.push(file.name);
        }
      }
    } finally {
      this.progressLoading = false;
    }
    return { fileUrls, fileNames };
  }

  /**
   * ### ファイルアップロード先のURLを発行する
   */
  public async createUploadUrls(files: Array<File>, s3LocationType: S3LocationType): Promise<Array<S3LocationResponse>> {
    let extensions: Array<string> = [];
    for (const file of files) {
      const _file: Array<string> = file.name.split("/");
      const _extensions: Array<string> = _file[_file.length - 1].split(".");
      extensions.push("." + _extensions[_extensions.length - 1]);
    }
    const params: S3LocationReceiveMessage = {
      residentId: this.currentOpinion.residentId,
      familyId: this.currentOpinion.familyId
    };
    const requestBody: S3LocationRequest = {
      type: s3LocationType,
      count: files.length,
      extensions: extensions,
      params: params,
      acl: "public-read"
    };
    const url: Array<S3LocationResponse> = await this.s3LocationsService.post(userStore, requestBody);

    return url;
  }

  /**
   * ### ファイルの存在確認を行う
   */
  public async existFile(fileUrls: Array<string>): Promise<void> {
    // ファイルがアップロードされているかをチェックする
    const fileRequestBody: ExistS3FilesPostModel = { urls: fileUrls };
    await this.existS3FilesService.post(userStore, fileRequestBody);

    // サムネイルのファイルが存在しているかをチェックする
    let thumbnailUrls: Array<string> = [];
    for (const url of fileUrls) {
      // サムネイルのファイル名は<元ファイル名>_thumbnailになる
      const splitedUrl: string[] = url.split("/");
      const splitedFileName: string[] = splitedUrl[splitedUrl.length - 1].split(".");

      // mov、mp4以外の場合はサムネイルをメッセージ送信時に作成するのでスキップ
      if (splitedFileName[1] != "mov" && splitedFileName[1] != "mp4") {
        continue;
      }

      const thumbnailFileName: string = splitedFileName[0] + "_thumbnail.jpeg";
      let thunmbnailUrl: string = "";
      for (let i = 0; i < splitedUrl.length - 1; i++) {
        thunmbnailUrl += splitedUrl[i] + "/";
      }
      thunmbnailUrl += thumbnailFileName;
      thumbnailUrls.push(thunmbnailUrl);
    }

    if (0 < thumbnailUrls.length) {
      const thumbnailRequestBody: ExistS3FilesPostModel = { urls: thumbnailUrls };
      await this.existS3FilesService.post(userStore, thumbnailRequestBody);
    }

    return;
  }

  /**
   * ### 登録用パラメータを作成する
   */
  public createRequestBody(uploadedFiles: { fileUrls: string[]; fileNames: string[] }): OpinionMessagesPostModel {
    const requestBody: OpinionMessagesPostModel = {
      residentId: this.currentOpinion.residentId,
      familyId: this.currentOpinion.familyId,
      familyRelation: this.messages[0].familyRelation,
      familyPosition: this.messages[0].familyPosition,
      content: this.$stringUtil.convertYen(this.text),
      sender: "bot",
      senderType: SendType.FACILITY,
      receiver: this.messages[0].sender,
      fileUrls: uploadedFiles.fileUrls,
      fileNames: uploadedFiles.fileNames
    };

    return requestBody;
  }

  public async createAttachedFiles(): Promise<AttachedFile[] | null> {
    if (this.files.length <= 0) {
      return null;
    }
    const attachedFiles: AttachedFile[] = [];
    for (let i = 0; i < this.files.length; i++) {
      const index: number = this.allowContentType.indexOf(this.files[i].type);
      const messageType: string = this.allowMessageType[index];

      attachedFiles.push({
        type: messageType,
        url: await FileReaderWrapper.readAsDataURL(this.files[i]),
        name: this.files[i].name
      });
    }
    return attachedFiles;
  }

  /**
   * ### 投稿日時を画面表示用の文字列に変換する
   */
  public convertDate(date: number) {
    const convertedDate: string = this.$dateUtil.convertNumberToString(date, "yyyy/mm/dd hh:MM");
    return convertedDate;
  }

  public createSendMessageContents(message: OpinionMessagesGetModel): Array<{ type: string; value: string; uri?: string; url?: string; fileName?: string }> {
    // contentが存在しない場合は空配列を返す
    if (!message.content) {
      return [];
    }

    // template側でlinkボタンとテキストを判別するためにtypeを持たせる
    let contents: Array<{ type: string; value: string; uri?: string; url?: string; fileName?: string }> = [];

    const splitedContent: string[] = message.content.split("\n");
    let buttonCount: number = 1;

    for (const message of splitedContent) {
      // リンクボタンメッセージ(ボタン名指定)
      // 先頭に半角全角スペースがあるだけの場合は無視して扱い、それ以外はテキスト文字列として扱う
      if (message.match(/^\[(.*)\]\((.*)\)$/)) {
        const linkRegex = /\[(.*?)\]\((.*?)\)/g;
        const links: Array<{ name: string; url: string }> = [];
        let match: any;

        while ((match = linkRegex.exec(message)) !== null) {
          const name = match[1] ? match[1] : null;
          const url = match[2] ? match[2] : null;
          links.push({ name, url });
        }

        if (links.length == 1 && links[0].name != null && links[0].url != null) {
          contents.push({
            type: "link",
            value: `${links[0].name}`,
            uri: links[0].url
          });
        } else {
          contents.push({
            type: "text",
            value: message
          });
        }
      }
      // リンクボタンメッセージ(ボタン名指定無し)
      // 先頭に半角全角スペースがあるだけの場合はURLとして扱い、それ以外はテキスト文字列として扱う
      else if (message.match(/^\s*(http|https):\/\/.+/)) {
        // 前後の半角全角スペースを取り除き、URLデコード&エンコードを考慮したURIを作成する
        const uri: string = message.replace(/^\s+|\s+$/g, "");
        const decodedUri: string = decodeURI(uri);
        const encodedUri: string = encodeURI(decodedUri);

        buttonCount++;
        contents.push({
          type: "link",
          value: `リンク その${buttonCount}`,
          uri: encodedUri
        });
      }
      // テキストメッセージ
      else {
        const convertedMessage: string = message == "" ? "　" : message;
        contents.push({
          type: "text",
          value: convertedMessage
        });
      }
    }

    // 添付ファイルがある場合は添付ファイルもコンテンツとする
    if (message.attachedFiles) {
      for (const file of message.attachedFiles) {
        if (file.type == "image") {
          contents.push({
            type: file.type,
            value: "",
            url: file.url,
            fileName: file.name
          });
        } else if (file.type == "pdf") {
          contents.push({
            type: file.type,
            value: "",
            url: file.url,
            fileName: file.name
          });
        }
      }
    }

    return contents;
  }

  /**
   * ### 画像をモーダル表示する
   */
  public showImage(url: string, fileName: string): void {
    this.imageUrl = url;
    const opinion = this.currentOpinion as OpinionMessageTableItem;
    this.imageFileName = `HitomeQコネクト-受信メッセージ（家族連絡）-${opinion.residentName}（${opinion.familyName}）-${fileName}`;
    this.showImageDownloadModal = true;
    return;
  }

  /**
   * ### PDFをモーダル表示する
   */
  public showPdf(file: { type: string; url: string }): void {
    this.pdfUrl = file.url;
    this.showPdfModal = true;
    return;
  }

  /**
   * ### 子コンポーネントでファイルが選択された場合のイベント処理
   *
   * - ファイルが上限数以上なら無視する
   * - バリデーションを行う
   * - バリデーションエラーでなければ、ファイルを親コンポーネントに渡す
   */
  public async inputFiles(files: Array<File>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const receiveMessageFormCommonService: ReceiveMessageFormCommon = new ReceiveMessageFormCommon(this.$validator, "tempfiles-multiple-register-errors");
    const addFiles: Array<File> = await receiveMessageFormCommonService.createAddFile(files, this.fileUploadLimit, this.files.length, this.needConvertPdf);

    this.isBusy = false;

    if (0 < addFiles.length) {
      this.files = this.files.concat(addFiles);

      for (let i = 0; i < this.files.length; i++) {
        this.files[i].key = i.toString();
      }
    }

    return;
  }

  /**
   * ### 指定されたファイルを削除する
   */
  public onFileDelete(index: number): void {
    this.files.splice(index, 1);
    return;
  }

  /**
   * ### 添付ファイルプレビューボタン押下イベント処理
   *
   * - ダイアログで添付ファイルをプレビュー表示する
   */
  public onTempFilePreview(): void {
    this.previewModal.show("", false, this.files);
    return;
  }
}

export interface OpinionMessageField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

export interface OpinionMessageTableItem {
  functionContents: { hidden: boolean; familyRelation: string; content: string; isFinished: boolean };
  residentId: number;
  residentName: string;
  familyId: number;
  familyName: string;
  datetime: number;
  groupId: number;
  caseId: number;
  selected: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.reply-receive-message-tab {
  margin-left: auto;
  margin-right: auto;

  @mixin title() {
    background-color: $bg-header;
    padding: 5px;
    min-height: 32px;
    font-weight: bold;
    text-align: center;
  }

  .box {
    margin-bottom: 0;
  }

  .message-histories {
    // デフォルトフォントサイズを指定する
    font-size: 16px;
    // 外枠はここで描画させる
    border: solid 1px $border-darkgray;

    .message-list-title {
      @include title();
      border-bottom: solid 1px $border-lightgray;
      min-height: 35px;
    }

    // 左側、メッセージリスト
    .message-list {
      min-width: 50%;
      max-width: 50%;
      overflow-y: auto;
      overflow-x: auto;

      .message-content {
        overflow-y: scroll;
        overflow-x: auto;
        position: relative;
        max-height: calc(100vh - 265px);
        // 背景色
        background-color: $bg-message;

        .message {
          padding: 10px 0 10px 0;
          // botの発言
          .line-left {
            position: relative;
            display: inline-block;
            margin-bottom: 5px;
            clear: both;
            margin-left: 30px;
            max-width: 740px;
            // 発言本文
            .text {
              padding: 10px;
              border-radius: 20px;
              background-color: $bg-message-bot;
              margin: 0;
              margin-right: 80px;
              // LINEの吹き出しのように見せるために、CSSで図形を描画
              &::after {
                content: "";
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                left: -10px;
                top: 10px;
                border-right: 20px solid $bg-message-bot;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
              }
            }
            // 日付部分
            .date {
              color: $date-font-color;
              text-align: left;
              font-size: 14px;
              font-weight: bold;
            }
          }
          // 自分の発言
          .line-right {
            position: relative;
            margin-top: 5px;
            float: right;
            clear: both;
            margin-right: 30px;
            max-width: 740px;
            // 発言本文
            .text {
              padding: 10px;
              border-radius: 20px;
              background-color: $bg-message-mine;
              color: rgba(255, 255, 255, 1);
              margin: 0;
              margin-left: 80px;
              // LINEの吹き出しのように見せるために、CSSで図形を描画
              &::after {
                content: "";
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                right: -10px;
                top: 10px;
                border-left: 20px solid $bg-message-mine;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
              }
            }
            // 日付部分
            .date {
              color: $date-font-color;
              text-align: right;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
      }
    }
    // 右側、メッセージリスト
    .reply-content {
      min-width: 50%;
      max-width: 50%;
      max-height: calc(100vh - 231px);
      overflow-y: auto;
      overflow-x: auto;
      border-left: solid 1px $border-darkgray;

      .reply-input {
        textarea {
          height: 246px;
          width: 100%;
          // デザインが崩れるのでリサイズは無効にする
          resize: none;
          @include font(16px);
          background-image: none;
          background-color: $bg-default;
          border: 1px solid $form-border-color;
          border-radius: 0.25rem;
          &.disable {
            cursor: not-allowed;
            background-color: $btn-disable !important;
          }
        }
      }
      // 入力欄にフォーカスが当たった際は強調する
      input:focus,
      textarea:focus,
      select:focus {
        // chromeが自動的に付与するスタイルを無効化する
        outline: none;
        box-shadow: 0 0 0 0.2rem $form-boxshadow-select-color;
        border: 1px solid $form-border-select-color !important;
        border-radius: 0.25rem;
      }

      .need-convert-pdf {
        margin: 8px 0 8px 0;
        // 画像でセレクトボックスを表現するので、input要素自体は非表示にする
        input[type="checkbox"] {
          display: none;
          // input要素の代わりに画像つきのspanにする
          // 選択しているか否かで画像を切り替える
          // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
          & + span {
            // チェックボックス画像が全て表示されるように高さを指定する
            height: 46px;
            // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
            padding: 6px 0 0 40px;
            background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
            // チェックボックス画像のサイズを指定
            // 正方形なので要素の高さと同じになる
            background-size: 32px 32px;
          }
          &:checked + span {
            background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
            // チェックボックス画像のサイズを指定
            // 正方形なので要素の高さと同じになる
            background-size: 32px 32px;
          }
        }
        .text {
          margin: 0 !important;
        }
      }
      .reply-btn {
        width: 104px;
      }
    }
    // LINE風に表示を行うため、vueがメッセージの情報を取得後、スクロールバーの位置を一番下に移動させている
    // vueがDOM要素を作成した後、img要素のsrc属性のURLにGETが走り、画像が取得される
    // 画像の大きさを固定しておかなかった場合、img要素は動的に高さが変わり、スクロールバーの長さが変わる
    // スクロールバーの長さが変わると、スクロール位置もずれてしまい、位置が一番下ではなくなってしまう
    // これを回避するため、画像を表示するdiv要素の高さおよびimg要素の高さを固定し、img要素の高さが動的に変わるのを防ぐ
    .image {
      // 「ここで高さを固定しないと、問題が発生するため、高さ固定」とあるが、max-heightで問題がないか確認する
      // height: 320px;
      max-height: 320px;
      img {
        // 画像サイズは高さ固定
        height: 300px;
        max-width: 700px;
      }
      cursor: pointer;
    }
    .link {
      padding: 8px;
      cursor: pointer;
      a {
        color: $font-key-color;
      }
    }
  }
}
</style>
